"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenReaderOnly = exports.screenReaderOnly = void 0;
const styled_1 = __importDefault(require("./styled"));
exports.screenReaderOnly = {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'polygon(0px 0px, 0px 0px, 0px 0px)',
    WebkitClipPath: 'polygon(0px 0px, 0px 0px, 0px 0px)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px',
    whiteSpace: 'nowrap',
    color: 'transparent',
};
exports.ScreenReaderOnly = styled_1.default.div(Object.assign({}, exports.screenReaderOnly));
//# sourceMappingURL=a11y_helpers.js.map